export default __webpack_public_path__ + "static/media/yellow-box-crop.d7d26a88.jpg";